// src/components/ToasterHost.jsx
import React from "react";
import { Toaster } from "react-hot-toast";

const ToastKeyframes = () => (
  <style>{`
    @keyframes shrink { from { transform: scaleX(1); } to { transform: scaleX(0); } }
  `}</style>
);

export default function ToasterHost() {
  return (
    <>
      <Toaster
        position="top-right"
        gutter={8}
        toastOptions={{
          duration: 4000,
          //   style: { background: "transparent", boxShadow: "none", padding: 0 }
          style: {
            background: "#363636",
            color: "#fff",
          },
        }}
      />
      <ToastKeyframes />
    </>
  );
}
